<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent" ref="purchasestockbillTable"></vxe-grid>
					
				<vxe-modal v-model="unitmodal" :title='unitmodaltitle + "单位"' width="300" height="200" show-footer destroy-on-close>
					<template #default>
						<el-checkbox-group v-model="currentsourcerow.useableunit">
							<el-checkbox v-for="(item) in currentsourcerow.totalunit" :label="item" :key="item"></el-checkbox>
						</el-checkbox-group>
					</template>
					<template #footer>
						<vxe-button status="" content="返回" @click="unitmodalcancel"></vxe-button>
						<vxe-button status="primary" content="确认" @click="unitmodalsubmit"></vxe-button>
					</template>
				</vxe-modal>
				
				<vxe-modal v-model="splitmodal" :title='unitmodaltitle + "拆分金额"' width="500" height="300" show-footer destroy-on-close>
					<template #default>
						<el-form label-width="80px">
							<el-form-item label="项目名称">
								<el-select v-model="splitinventoryitem" placeholder="请选择" size="mini" filterable clearable>
									<el-option v-for="(item,index) in splitinventory" :key="index" :label="item.label" :value="item.value" :disabled="item.disabled"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="拆出金额">
								<el-input-number v-model="splitprice" :min="1" size="mini" :precision="4" ></el-input-number>
							</el-form-item>
						</el-form>
					</template>
					<template #footer>
						<vxe-button status="" content="返回" @click="splitmodalcancel"></vxe-button>
						<vxe-button status="primary" content="确认" @click="splitmodalsubmit"></vxe-button>
					</template>
				</vxe-modal>
					
					
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="创建采购入库单" @click="createpurchase"></vxe-button>
			</template>
		</vxe-modal>
		

		
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
			invoicedetailgroupdata: {
				default: () => {
					return []
				}
			},
			store: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading:false,
				unitmodal:false,
				unitmodaltitle:'',
				splitmodal:false,
				splitmodaltitle:'',
				splitinventoryitem:null,
				splitprice:1,
				splitinventory:[],
				currentsourcerow:null,
				
				modal_model: false,
				modal_title: '采购入库单',
				modal_width: 1000,
				modal_height: 600,
				sourceData:[],
				inventoryreport:[],
				list_footerField: [{
					field: 'price',
					toFixed: 4
				},{
					field: 'endAmount',
					toFixed: 4
				},{
					field: 'newEndAmount',
					toFixed: 4
				}]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			list_beforeCreateGrid(gridOptions) {
				gridOptions.columns = [{
						field: 'nazhi_inventoryname',
						title: '项目名称',
					},
					{
						field: 'unit',
						title: '入库单位',
						width:50
					},
					{
						field: 'amount',
						title: '入库数量'
					},
					{
						field: 'price',
						title: '入库金额',
					},
					{
						field: 'endUnitPrice',
						title: '结存单价',
					},
					{
						field: 'endAmount',
						title: '原结存金额',
						slots:{
							default:({row})=>{
								if(row.endAmount<0){
									return <span style="color:#F56C6C">{row.endAmount}</span>
								}else{
									return row.endAmount
								}
							}
						}
					},
					{
						field: 'newEndAmount',
						title: '入库后结存金额',
						slots:{
							default:({row})=>{
								if(row.newEndAmount<0){
									return <span style="color:#F56C6C">{row.newEndAmount}</span>
								}else{
									return row.newEndAmount
								}
							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 150,
						slots: {
							default: ({row}) => {
								if(!row.split){
									return [
										<el-button type = "text" size = "mini" onClick = {() => {this.unitmodalShow(row)}}>入库单位</el-button>,
										<el-button type = "text" size = "mini" onClick = {() => {this.splitmodalShow(row)}}>拆分金额</el-button>,
									]
								}else{
									return [
										<el-button type = "text" size = "mini" onClick = {() => {this.del(row)}}>删除</el-button>,
									]
								}

							}
						}
					}
				]
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = false
			},
			list() {
				return new Promise((resolve) => {
					console.log(this.invoicedetailgroupdata)
					this.inventoryreport = this.store.inventoryreport
					
					let inventoryreportMap = this.inventoryreport.map((item)=>{
						return {
							id:item.id,
							inventoryName:item.inventoryName,
							unit:item.unit,
							endAmount:item.endAmount,
							endUnitPrice:item.endUnitPrice
						}
					})
					let inventoryMap = this.store.inventory.map((item)=>{
						return {
							id:item.id,
							inventoryName:item.name,
							unit:item.unit,
							endAmount:1,
							endUnitPrice:0
						}
					})
					
					let sourceData = []
					for (let i in this.invoicedetailgroupdata) {
						let obj = {
							id:this.invoicedetailgroupdata[i].id,
							nazhi_inventoryname: this.invoicedetailgroupdata[i].nazhi_inventoryname,
							price: this.invoicedetailgroupdata[i].price,
							unitPrice: this.invoicedetailgroupdata[i].unitPrice,
							totalunit:[],
							useableunit:[],
							split:[]
						}
						let relationinventory = inventoryreportMap.filter((item)=>{
							return item.inventoryName == obj.nazhi_inventoryname
						})
						if(!relationinventory.length){
							relationinventory = inventoryMap.filter((item)=>{
								return item.inventoryName == obj.nazhi_inventoryname
							})
						}
						obj.relationinventory = relationinventory
						obj.totalunit = relationinventory.map((item)=>{
							return item.unit
						})
						obj.useableunit = relationinventory.map((item)=>{
							return item.unit
						})
						sourceData.push(obj)
					}
					this.sourceData = sourceData
					//console.log(sourceData)					
					resolve({
						list: this.createTableData()
					})
				})
			},
			createTableData() {
				console.log(this.sourceData)
				let data = []
				this.sourceData.forEach((item)=>{					
					let relationinventory = item.relationinventory.filter((rv)=>{
						return item.useableunit.includes(rv.unit)
					})
					let split = item.split
					
					let totalOutAmount = this.$Lodash.sumBy(relationinventory,(v)=>{return parseFloat(v.endAmount)})
					let totalprice = item.price - this.$Lodash.sumBy(split,(v)=>{return parseFloat(v.price)})
					relationinventory.forEach((_item)=>{
						let obj = {}
						obj.split = false
						obj.sourcedataid = item.id
						obj.id = _item.id
						obj.nazhi_inventoryname = _item.inventoryName
						obj.unit = _item.unit						
						obj.endUnitPrice = _item.endUnitPrice ? _item.endUnitPrice : item.unitPrice
						obj.price = totalprice * (_item.endAmount / totalOutAmount)
						obj.endAmount = _item.endAmount
						obj.newEndAmount = parseFloat(_item.endAmount) + obj.price
						obj.amount = obj.price / obj.endUnitPrice						
						obj.amount = obj.amount.toFixed(4)
						obj.newEndAmount = obj.newEndAmount.toFixed(4)
						obj.price = obj.price.toFixed(4)						
						data.push(obj)
					})
					
					split.forEach((_item)=>{
						let splititem = _item.item
						let price = _item.price
						let splitobj = {}
						splitobj.split = true
						splitobj.sourcedataid = item.id
						splitobj.id = splititem.id
						splitobj.nazhi_inventoryname = splititem.inventoryName
						splitobj.unit = splititem.unit						
						splitobj.endUnitPrice = splititem.endUnitPrice
						splitobj.price = price
						splitobj.endAmount = splititem.endAmount
						splitobj.newEndAmount = parseFloat(splititem.endAmount) + splitobj.price
						splitobj.amount = splitobj.price / splitobj.endUnitPrice	
						splitobj.split = split				
						splitobj.amount = splitobj.amount.toFixed(4)
						splitobj.newEndAmount = splitobj.newEndAmount.toFixed(4)
						splitobj.price = splitobj.price.toFixed(4)						
						data.push(splitobj)
					})																					
				})	
				console.log(data)
				return data
			},
			unitmodalShow(row){
				this.currentsourcerow = this.sourceData.find((item)=>{
					return item.id == row.sourcedataid
				})				
				console.log(this.currentsourcerow)
				if(this.currentsourcerow){
					this.unitmodaltitle = '【'+this.currentsourcerow.nazhi_inventoryname+'】'
					this.unitmodal = true
				}				
			},
			unitmodalsubmit(){
				if(!this.currentsourcerow.useableunit.length){
					this.$message.error('至少包含一个入库单位')
					return
				}
				let data = this.createTableData()
				this.$refs.purchasestockbillTable.reloadData(data)
				this.unitmodalcancel()
				
			},
			unitmodalcancel(){
				this.unitmodal = false
				this.unitmodaltitle = ''
				this.currentsourcerow = null
			},
			splitmodalShow(row){
				let tabledata = this.$refs.purchasestockbillTable.getTableData().fullData
				this.currentsourcerow = this.sourceData.find((item)=>{
					return item.id == row.sourcedataid
				})				
				//console.log(this.currentsourcerow)
				if(this.currentsourcerow){
					this.splitinventory = this.inventoryreport.map((item)=>{
						return {
							value:item.id,
							label:item.inventoryName + '【'+item.unit+'】' + '结存金额【'+item.endAmount+'】',
							obj:item
						}
					})
					this.splitinventory.forEach((item)=>{
						let exist = tabledata.find((_item)=>{
							return _item.nazhi_inventoryname == item.obj.inventoryName && _item.unit == item.obj.unit
						})
						if(exist){
							item.disabled = true
						}else{
							item.disabled = false
						}						
					})
					this.splitmodaltitle = '【'+this.currentsourcerow.nazhi_inventoryname+'】'
					this.splitmodal = true
				}
			},
			splitmodalsubmit(){				
				let target = this.splitinventory.find((item)=>{
					return this.splitinventoryitem == item.value
				})
				if(target){
					this.currentsourcerow.split.push({
						item:target.obj,
						price:this.splitprice
					})
				}
				let data = this.createTableData()
				this.$refs.purchasestockbillTable.reloadData(data)
				this.splitmodalcancel()
				//console.log(this.splitinventoryitem,this.splitprice,this.splitinventory)
			},
			createpurchase(){
				this.loading = true
				let data = this.createTableData()
				this.$api.invoice.createPurchase({
					data:data,
					invoiceId:this.invoicedata.invoiceId
				}).then(() => {
					this.$message.success('操作成功')
					this.loading = false
					this.modal_cancel()
				}, () => {
					this.loading = false
				})
				
			},
			splitmodalcancel(){
				this.splitmodal = false
				this.splitmodaltitle =''
				this.splitinventoryitem =null
				this.splitprice = 1
				this.splitinventory = []
				this.currentsourcerow = null
			},
			del(row){
				let index = row.split.findIndex((item)=>{
					return item.item.id == row.id
				})
				//console.log(row,row.split)
				if(index!==-1){
					row.split.splice(index,1)
					let data = this.createTableData()
					this.$refs.purchasestockbillTable.reloadData(data)
				}
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>